import { connect } from 'react-redux'
import { selectors } from '../../features/Settings'
import SideMenu from '../../components/SideMenu'
import localize from '../../store/localize'
import attributes from '../../settings/references.json'
import strings from '../../components/SideMenu/side-menu.json'
import { actionAppSetShowSettingsState } from '../../actions'

function mapStateToProps(state) {
    const { app, versions, steam, sync } = state
    const LauncherType = selectors.getLauncherType(state)
    // Launcher version checker
    // Figure out which version type we're using
    const launcherType = attributes.launcher.versionTypes[LauncherType]
    // Get the version number from the sync file
    const syncLauncherVersion = sync.versions[launcherType]
    // Check if an update is currently available
    const updateAvailable =
        syncLauncherVersion !== undefined &&
        versions.ui !== '-1' &&
        versions.ui !== syncLauncherVersion
    // Get search & hash
    const search = window.location.search
    const hash = window.location.hash
    // Set the new version path
    // < 2000 backwards compatibility included
    const newVersion =
        syncLauncherVersion < 2000
            ? `${syncLauncherVersion}/${search}${hash}`
            : `${launcherType}/${syncLauncherVersion}/${search}${hash}`

    const locale = selectors.getLanguage(state)
    return {
        showSettings: app.showSettings,
        steamStartup: steam.steamStartup,
        twitch: sync.twitch,
        newVersion,
        updateAvailable,
        localize: value => localize(strings, locale, value),
        locale,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSettingsVisibility: (visible) => {
            dispatch(actionAppSetShowSettingsState(visible))
        },
    }
}

function mergeProps(stateProps, dispatchProps) {
    return {
        steamStartup: stateProps.steamStartup,
        localize: stateProps.localize,
        locale: stateProps.locale,
        twitch: stateProps.twitch,
        newVersion: stateProps.newVersion,
        updateAvailable: stateProps.updateAvailable,
        settingsOpen: stateProps.showSettings,
        toggleSettings: () => {
            dispatchProps.setSettingsVisibility(!stateProps.showSettings)
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SideMenu)



// WEBPACK FOOTER //
// ./src/containers/SideMenu/side-menu.js